export const normalizeSearchInput = value => {
  if (!value) {
    return value;
  }

  return value.replace(/[^A-Za-z0-9\s\-\\]+/g, '');
};
